import React, { useState } from 'react'
import { AssistantPropsType } from './types'

// Icons
import IconAssistant from './images/iconAssistant'
import IconAssistantWinking from './images/iconAssistantWinking'
import IconClose from './images/iconClose'

// Styles
import './styles.scss'

export default ({ text, background, style, isWinking }: AssistantPropsType) => {
  const [isShow, setIsShow] = useState<boolean>(true)

  const handleHideAssistant = () => {
    setIsShow(false)
  }

  return isShow ? (
    <div className={'assistant'} style={style}>
      <div
        className={'assistant__message'}
        style={background ? { background } : {}}
      >
        <div
          className={'assistant__message-text'}
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <div className={'assistant__message-close'}>
          <IconClose onClick={handleHideAssistant} />
        </div>
        <div
          className={'assistant__message-arrow'}
          style={background ? { background } : {}}
        ></div>
      </div>
      <div className={'assistant__icon'}>
        {isWinking ? <IconAssistantWinking /> : <IconAssistant />}
      </div>
    </div>
  ) : null
}
